import { useTranslation } from 'react-i18next'

import X from '@/presentation/assets/svg/X.svg'
import Button from '@/presentation/components/Button'

interface ConfirmDeleteDivergencePopupProps {
  onCancel: () => void
  onConfirmButton: () => void
}

const ConfirmDeleteDivergencePopup: React.FC<
  ConfirmDeleteDivergencePopupProps
> = ({ onCancel, onConfirmButton }) => {
  const { t } = useTranslation()

  return (
    <div
      onClick={() => onCancel()}
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#70707059] px-4"
    >
      <div
        className="flex max-w-[460px] flex-col rounded-lg bg-white p-4 px-6"
        onClick={event => event.stopPropagation()}
      >
        <div className="mb-1 flex items-center justify-between">
          <span className="text-lg text-gray-700">
            {t('ARE_YOU_SURE', 'Tem certeza?')}
          </span>

          <img src={X} onClick={() => onCancel()} className="cursor-pointer" />
        </div>

        <hr className="mb-4" />

        <span className="mb-4 text-gray-700">
          {t(
            'DELETE_CONTESTATION_WARNING',
            'Você está prestes a excluir todas as suas observações referentes a contestação deste item.'
          )}
        </span>

        <div className="flex flex-col gap-y-4">
          <Button styleType="danger" onClick={() => onConfirmButton()}>
            {t('DELETE_CONTESTATION', 'Excluir contestação')}
          </Button>

          <Button styleType="outline" colored onClick={() => onCancel()}>
            {t('CANCEL', 'Cancelar')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmDeleteDivergencePopup
